<style>
</style>

<script lang="ts">
  import logo from '../resources/assets/logo.svg'
  import { locale } from 'svelte-i18n'
</script>

<div class="d-flex justify-content-center align-items-center h-100">
  <div class="text-center">
    <div class="d-flex mt-5 align-items-end">
      <h2 class="text-primary-a me-2">404</h2>
      {#if $locale == 'pt'}
        <p>
          <strong>A página não foi encontrada.</strong>
        </p>
      {:else if $locale == 'es'}
        <p>
          <strong>No se encontró la página.</strong>
        </p>
      {:else if $locale == 'fr'}
        <p>
          <strong>La page n'a pas été trouvée.</strong>
        </p>
      {:else}
        <p>
          <strong>The page was not found.</strong>
        </p>
      {/if}
    </div>
  </div>
</div>
